export default __webpack_public_path__ + "static/media/ecommerce-laptop-main.8028addb.webp";